import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackAppearanceModeChangedSpec,
  type AppearanceModeChanged,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const appearanceEvents: SnowplowEventMap = {
  [TrackingEventName.AppearanceModeChanged]: (props) =>
    trackAppearanceModeChangedSpec(props as AppearanceModeChanged),
};
